import { createContext, use } from 'react';

type TextareaAutogrowContextValue = {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
};

export const TextareaAutogrowContext = createContext<TextareaAutogrowContextValue | undefined>(undefined);

export function useTextareaAutogrowContext() {
  const context = use(TextareaAutogrowContext);

  if (!context) {
    throw new Error('This component must be used as a child of useTextareaAutogrowContainer component');
  }
  return context;
}
